import { z } from 'zod';
import { isLexicalStateNotEmpty } from '@/lib/lexical';

export const postCommentSchema = z.object({
  comment: z.string().refine(isLexicalStateNotEmpty, "Comment can't be empty"),
});
